<template>
  <h6 class="mb-1">{{ order }}) {{ freeField1 }}</h6>
  <p>{{ freeField2 }}</p>
  <div class="d-flex">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="btn btn-link btn-satisfaction-scale"
      :class="{ selected: value === option.value }"
      :title="option.label"
      @click="setValue(option.value)"
    >
      <div class="d-flex flex-column align-items-center">
        <span class="radio-circle" :class="circleClass(option.value)"></span>
        <p class="mb-0">{{ option.label }}</p>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SatisfactionScale',

  props: {
    order: {
      type: [String, Number],
      default: '1',
    },
    freeField1: {
      type: String,
      default: 'Qual é sua avaliação',
    },
    freeField2: {
      type: String,
      default: '',
    },
    freeField3: {
      type: String,
      default: '',
    },
    userDistribution: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      options: [
        { value: 1, label: 'Muito insatisfeito' },
        { value: 2, label: 'Insatisfeito' },
        { value: 3, label: 'Indiferente' },
        { value: 4, label: 'Satisfeito' },
        { value: 5, label: 'Muito satisfeito' },
      ],
      value: '',
    }
  },

  emits: ['setValue'],

  methods: {
    setValue(value) {
      if (this.userDistribution) {
        const newUserDistribution = { ...this.userDistribution }
        newUserDistribution.value = value
        this.$emit('setValue', newUserDistribution)
      }
      this.value = value
    },

    circleClass(value) {
      if (this.value === value) {
        if (value === 1) return 'bg-red'
        if (value === 2) return 'bg-orage'
        if (value === 3) return 'bg-yellow'
        if (value === 4) return 'bg-green'
        if (value === 5) return 'bg-green-light'
      }
      return ''
    },
  },

  mounted() {
    if (this.userDistribution) {
      this.value = this.userDistribution.value
    }
  },
}
</script>

<style scoped>
.btn-satisfaction-scale {
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  outline: none;
  margin: 0 14px;
}

.radio-circle {
  width: 35px;
  height: 35px;
  margin-bottom: 5px;
  border-radius: 50%;
  border: 3px solid #ccc;
  transition: background-color 0.3s, border-color 0.3s;
}

.btn-satisfaction-scale.selected .radio-circle.bg-red {
  background-color: #d93550;
  border: 3px solid #b71c1c;
}

.btn-satisfaction-scale.selected .radio-circle.bg-orage {
  background-color: #f9704e;
  border: 3px solid #e64a33;
}

.btn-satisfaction-scale.selected .radio-circle.bg-yellow {
  background-color: #fcc40a;
  border: 3px solid #f9b008;
}

.btn-satisfaction-scale.selected .radio-circle.bg-green {
  background-color: #24a08a;
  border: 3px solid #1d806a;
}

.btn-satisfaction-scale.selected .radio-circle.bg-green-light {
  background-color: #34c077;
  border: 3px solid #1f8c66;
}

.btn-satisfaction-scale p {
  font-size: 12px;
  font-weight: 400;
  color: #000;
  transition: all 0.3s ease;
}
</style>
